module.exports = __webpack_public_path__ + "static/media/header_img.80e78ac8.jpg";